module.exports = __webpack_public_path__ + "static/media/ic_close.e56f70f8.svg";